import { jsx as x } from "react/jsx-runtime";
import "react";
import { classNames as i } from "../../utilities/index.js";
const p = _ref => {
    let {
      fluid: s,
      width: t,
      noPadding: r,
      children: a,
      className: o,
      style: n,
      ...e
    } = _ref;
    const m = i({
      "sash-Container w-full mx-auto": !0,
      "px-6 md:px-8 xl:px-16": !r,
      [o]: o
    });
    return /* @__PURE__ */x("div", {
      className: m,
      style: {
        maxWidth: s ? "100%" : t ? `${t * 1}px` : 1568,
        ...n
      },
      ...e,
      children: a
    });
  },
  f = p;
export { f as default };